/**
 * Thrown when a component with a http call gives an error response.
 */
export default class ResponseError extends Error {

    /**
     * Creates a new instance of ResponseError
     * @param {string} responseError The http status code
     */
    constructor(responseError) {
        super(`The http call returned an error: ${responseError}`);
    }
}



// WEBPACK FOOTER //
// ./source/framework/errors/ResponseError.js